import React, { useCallback } from 'react';
import { ModalType, useModalContext } from '@/context/ModalContext';
import { NeedVpnErrorIcon } from '@/icons/errors';
import BaseModal from '@/components/Modal/BaseModal/BaseModal';
import {
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalContentText,
  ModalHeader,
  ModalIcon,
  ModalTitle,
} from '@/components/Modal/Elements';
import CloseButton from '@/components/Modal/Elements/Close/CloseButton';
import { useTranslation } from '@/hooks/useTranslation';

interface Props {}

const VpnErrorModal: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { close } = useModalContext();
  const onClose = useCallback(() => {
    close(ModalType.NEED_VPN);
  }, []);

  return (
    <BaseModal onClose={onClose}>
      <ModalHeader>
        <CloseButton onClick={onClose} />
      </ModalHeader>
      <ModalIcon>
        <NeedVpnErrorIcon />
      </ModalIcon>
      <ModalContent>
        <ModalTitle>{t('modal.error.need_vpn.title')}</ModalTitle>
        <ModalContentText>{t('modal.error.need_vpn.sub_title')}</ModalContentText>
      </ModalContent>
      <ModalActions>
        <ModalCancelButton onClick={onClose} text={t('button.ok')} />
      </ModalActions>
    </BaseModal>
  );
};

export default VpnErrorModal;
